import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'maquinas',
})
export class MaquinasPipe implements PipeTransform {

  transform(items: any[], filter: { id_local: number, id_departamento: number }) {

    if (items) {

      if (filter && filter.id_local) {
        items = items.filter((item) => item.id_local == filter.id_local);
      }

      if (filter && filter.id_departamento) {
        items = items.filter((item) => item.id_departamento == filter.id_departamento);
      }

      return items;

    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/maquinas/maquinas.ts